import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    overflow: 'auto',
    scrollBehavior: 'smooth',
  },
}));

export default useStyles;
